/*! upsell-xs.js — termékoldali tartozék-ajánló (a natív „S-ar putea să îți placă și următoarele” szekció helyett), NGM + MobilStore.
 * CSAK kompatibilis termék: a jelölteket a motor számolja (`<base>/xs/<bolt>/p/<NN>.json` → csoportkulcs → `g/<kulcs>.json`, változat-azonosítók);
 * a cím, ár, kép és az ÉLŐ rendelhetőség a bolt token nélküli Storefront API-jából jön, a látogató nyelvén (RO / HU). Nincs jelölt / hiba / kill switch /
 * kontroll-csoport → semmi nem jelenik meg (a konténer üres és nulla magas). Lusta indulás: a `load` után, böngésző-üresjáratban kéri az adatot, és csak akkor
 * rajzol, amikor a konténer 600 px-en belül van; az első kirajzolás legfeljebb 6 kártya, a többi lapozáskor.
 * Mérés: a kezelt / kontroll csoport a kosár `_ups_grp_x` attribútuma (t / c, az első besoroláskor a kosár-tokenből: sha256("<só>:xs:<token>"), utána
 * a kosáron tárolt érték marad — stickyGroup), az ajánlatból tett sor
 * `_ups_src` tulajdonsága `xs:<típus>:auto`. `?upsell_preview=1`: QA-nézet a holdout megkerülésével, jelölés és `_ups_src` nélkül (a kill switch érvényes).
 * textContent (nincs innerHTML), URL csak /products/…, kép csak a Shopify CDN-ről.
 */
(function (root) {
  'use strict';

  var TEXT = {
    title: 'Produse compatibile cu {nume}', titleAny: 'Produse compatibile', add: 'Adaugă în coș', added: 'Adăugat ✓', error: 'Nu s-a putut adăuga',
    prev: 'Înapoi', next: 'Înainte', rrp: 'Preț recomandat: {pret}', currency: 'lei',
    types: { charger: 'Încărcător', car_charger: 'Încărcător auto', cable: 'Cablu', lens: 'Protecție cameră', powerbank: 'Baterie externă', car_holder: 'Suport auto',
      audio: 'Căști', wireless: 'Încărcător wireless', film: 'Folie de protecție', case: 'Husă', airpods_case: 'Husă AirPods', watch_strap: 'Curea',
      watch_film: 'Folie ceas', watch_case: 'Husă ceas', tablet_case: 'Husă tabletă', tablet_film: 'Folie tabletă', stylus: 'Stylus',
      // a lefedettségi terv új típusai (L2, K1–K3): a motor még nem küldi őket — amíg nem, a címke hatástalan
      earbuds_case: 'Husă căști', ear_tips: 'Dopuri de schimb', watch_charger: 'Încărcător ceas', smartwatch: 'Smartwatch', hub: 'Hub USB-C',
      mouse: 'Mouse', laptop_case: 'Husă laptop' }
  };
  var TEXT_HU = {
    title: 'Kompatibilis termékek: {nume}', titleAny: 'Kompatibilis termékek', add: 'Kosárba', added: 'Kosárba téve ✓', error: 'Nem sikerült',
    prev: 'Előző', next: 'Következő', rrp: 'Ajánlott ár: {pret}',
    types: { charger: 'Töltő', car_charger: 'Autós töltő', cable: 'Kábel', lens: 'Kameravédő', powerbank: 'Powerbank', car_holder: 'Autós tartó',
      audio: 'Fülhallgató', wireless: 'Vezeték nélküli töltő', film: 'Kijelzővédő fólia', case: 'Tok', airpods_case: 'AirPods-tok', watch_strap: 'Óraszíj',
      watch_film: 'Órafólia', watch_case: 'Óratok', tablet_case: 'Tablettok', tablet_film: 'Tabletfólia', stylus: 'Érintőceruza',
      earbuds_case: 'Fülhallgató-tok', ear_tips: 'Fülpárna', watch_charger: 'Óratöltő', smartwatch: 'Okosóra', hub: 'USB-C hub',
      mouse: 'Egér', laptop_case: 'Laptoptok' }
  };
  var SHOPS = ['ngm', 'mbs'];
  var FIRST = 6;                                        // első kirajzolás legfeljebb ennyi kártya
  var MAX_IDS = 80;                                     // a Storefront-lekérés plafonja (a csoport jelöltjei + tartalék)
  var API = '/api/2025-07/graphql.json';

  // --- holdout: a Python holdout.bucket(token, "<só>:xs") — sha256("<só>:xs:<token>") első 4 bájtja (big-endian) mod 10000
  function bucket(token, salt) {
    var data = new TextEncoder().encode(salt + ':' + token);
    return root.crypto.subtle.digest('SHA-256', data).then(function (buf) { return new DataView(buf).getUint32(0, false) % 10000; });
  }
  function assignGroup(token, pct, salt) {
    return bucket(token, salt + ':xs').then(function (b) { return b < Math.round(pct * 100) ? 'control' : 'treatment'; });
  }

  // a besorolás ragadós (FOLLOWUP 10-28): üres kosárnál a Shopify minden /cart.js-re új tokent ad, a végleges tokent az első kosár-írás (a mi jelölésünk)
  // hozza létre → a tokenből újrasorsolt csoport a következő oldalon felülírná az elsőt. Ezért a kosáron már meglévő t / c marad, sorsolás csak jelölés nélkül.
  // 0% holdout (a BF-ablak): mindenki kezelt, és nincs írás — a tárolt besorolás érintetlen, a holdout visszakapcsolásakor a közben született kosár sorsol.
  function stickyGroup(cart, attr, pct, salt, token) {
    if (!(pct > 0)) return Promise.resolve({ g: 'treatment', mark: false });
    var have = cart && cart.attributes && cart.attributes[attr];
    if (have === 't' || have === 'c') return Promise.resolve({ g: have === 't' ? 'treatment' : 'control', mark: false });
    return assignGroup(token, pct, salt).then(function (g) { return { g: g, mark: true }; });
  }

  // a megjelenés döntése: kill switch / hiányzó index → semmi; QA-előnézet → 'preview'; élő csak az NGM-en, a QGSM `surfaces.xs` szerint
  function decide(idx, shop, forced) {
    if (!idx || idx.v !== 1 || idx.kill_switch) return 'off';
    if (forced) return 'preview';
    var cfg = shop === 'ngm' ? idx.xs : null;         // az MBS élő be/ki kapcsolója még nincs a QGSM-ben (shop=mbs) → csak QA-előnézet
    if (!cfg || cfg.enabled !== true) return 'off';
    var pct = cfg.holdout_pct;
    return typeof pct === 'number' && isFinite(pct) && pct >= 0 && pct <= 100 ? 'live' : 'control';      // hibás holdout → kontroll (zárt hiba)
  }

  function shard(pid) { var s = String(pid); return s.slice(-2).padStart(2, '0'); }

  // napi forgatás: ugyanazon a napon ugyanaz a sorrend (mérhető, gyorsítótárazható), naponta és termékoldalanként más
  function daySeed(now) { var d = now || new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
  function rotate(list, k) { if (!list.length) return []; var o = ((k % list.length) + list.length) % list.length; return list.slice(o).concat(list.slice(0, o)); }

  // a lekérendő változatok: típusonként a forgatott saját, majd a KOFF jelöltek (a sorrend a későbbi kiválasztásé)
  function plan(group, seed, pid) {
    var out = [], n = 0;
    (group.types || []).forEach(function (t, i) {
      if (!t || typeof t.t !== 'string') return;
      var k = seed + (Number(String(pid).slice(-4)) || 0) + i * 7;
      var own = rotate((t.own || []).filter(isId), k), koff = rotate((t.koff || []).filter(isId), k);
      out.push({ t: t.t, own: own, koff: koff });
      n += own.length + koff.length;
    });
    return out;
  }
  function isId(v) { return typeof v === 'number' && isFinite(v) && v > 0 && Math.floor(v) === v; }
  function planIds(p) { var ids = []; p.forEach(function (t) { ids = ids.concat(t.own, t.koff); }); return ids.slice(0, MAX_IDS); }

  // a végső kártyák: típusonként legfeljebb `cap` (előbb a rendelhető saját, utána a KOFF); körönként minden típusból egy (változatosság: a csak
  // KOFF-ban lévő típus — pl. kameravédő — sem szorul ki), a körön belül előbb a saját készlet, utána a KOFF; legfeljebb `max` kártya.
  // A kosárban lévő és a mostani termék változata kimarad.
  function interleave(p, info, cap, max, skip) {
    var per = p.map(function (t) {
      var picks = [];
      ['own', 'koff'].forEach(function (tier) {
        t[tier].forEach(function (v) {
          var x = info[v];
          if (picks.length < cap && x && x.available && !skip[v] && !(skip.handle && x.handle === skip.handle)) picks.push({ v: v, t: t.t, tier: tier, x: x });
        });
      });
      return picks;
    });
    var out = [];
    for (var r = 0; r < cap && out.length < max; r++) {
      var round = per.map(function (l) { return l[r]; }).filter(Boolean);
      round.filter(function (q) { return q.tier === 'own'; }).concat(round.filter(function (q) { return q.tier === 'koff'; })).forEach(function (q) {
        if (out.length < max) out.push(q);
      });
    }
    return out;
  }

  // Storefront API (token nélkül, saját origin): a látogató országa és nyelve szerinti cím / ár / kép / rendelhetőség
  function gql(ids, country, lang) {
    var c = typeof country === 'string' && /^[A-Z]{2}$/.test(country) ? country : null;
    var l = typeof lang === 'string' ? lang.toUpperCase().replace('-', '_') : '';
    l = /^[A-Z]{2}(_[A-Z]{2})?$/.test(l) ? l : null;
    var vars = ['$ids:[ID!]!'], ctx = [];
    if (c) { vars.push('$c:CountryCode'); ctx.push('country:$c'); }
    if (l) { vars.push('$l:LanguageCode'); ctx.push('language:$l'); }
    var img = 'url';                                 // a `url(transform:…)` régi „_360x360” fájlnevére a CDN egyes képeknél tartósan 502-t ad (mérve 10-29, MBS) → width-paraméter (sized)
    var q = 'query X(' + vars.join(',') + ')' + (ctx.length ? ' @inContext(' + ctx.join(',') + ')' : '') +
      '{nodes(ids:$ids){...on ProductVariant{id availableForSale price{amount} compareAtPrice{amount} image{' + img + '} product{title handle featuredImage{' + img + '}}}}}';
    var v = { ids: ids.map(function (id) { return 'gid://shopify/ProductVariant/' + id; }) };
    if (c) v.c = c;
    if (l) v.l = l;
    return { query: q, variables: v };
  }
  // a téma image_url-jének alakja: <eredeti>?v=…&width=360 (a CDN így méretez; a régi „_360x360” fájlnév egyes képeknél 502)
  function sized(u) { return typeof u === 'string' && u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=360' : null; }
  function parseNodes(data) {
    var info = {};
    (((data || {}).data || {}).nodes || []).forEach(function (n) {
      if (!n || typeof n.id !== 'string' || !n.product) return;
      var id = Number(n.id.split('/').pop());
      var price = Number(n.price && n.price.amount), was = Number(n.compareAtPrice && n.compareAtPrice.amount);
      if (!isId(id) || !isFinite(price) || typeof n.product.handle !== 'string' || typeof n.product.title !== 'string') return;
      info[id] = { available: n.availableForSale === true, title: n.product.title, handle: n.product.handle, price: price, was: isFinite(was) && was > price ? was : null,
        img: sized((n.image && n.image.url) || (n.product.featuredImage && n.product.featuredImage.url)) };
    });
    return info;
  }

  function safeImg(u) { return typeof u === 'string' && /^https:\/\/cdn\.shopify\.com\/[^\s"'<>]+$/.test(u) ? u : null; }
  function productUrl(rootPath, handle) {
    if (typeof handle !== 'string' || !handle || /^\.+$/.test(handle) || /[\/?#\s]/.test(handle)) return null;
    var r = typeof rootPath === 'string' && /^\/([a-z]{2}(-[a-z]{2})?\/)?$/i.test(rootPath) ? rootPath : '/';
    return r + 'products/' + encodeURIComponent(handle);
  }
  function fmt(n, cur) { return Number(n).toFixed(2).replace('.', ',') + ' ' + cur; }

  var cache = {};
  function getJson(url) {
    if (!cache[url]) {
      var p = root.fetch(url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; });
      cache[url] = p;
      p.then(function (v) { if (v === null) delete cache[url]; }, function () { delete cache[url]; });
    }
    return cache[url];
  }

  function el(tag, cls, text) {
    var e = root.document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function routesRoot() { var s = root.Shopify; return (s && s.routes && typeof s.routes.root === 'string') ? s.routes.root : '/'; }

  function cartJs() {
    return root.fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  // a csoport a kosáron (t = kezelt, c = kontroll); csak akkor írunk, ha még nem ez van rajta
  function markCart(cart, code) {
    if (cart && cart.attributes && cart.attributes._ups_grp_x === code) return Promise.resolve();
    return serial(function () {
      return root.fetch(routesRoot() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _ups_grp_x: code } })
      });
    }).catch(function () { /* a jelölés nem kritikus */ });
  }
  // a kosár-jelölések egy lapon SORBAN mennek (közös sor a window-on, az upsell-pdp.js is ezt használja): üres kosárnál a két párhuzamos /cart/update.js
  // két külön kosarat hoz létre, és az egyik jelölés elvész (mérve 10-29: 5 / 5 friss látogatónál az xs VAGY a pdp jele hiányzott az 1. oldal után)
  function serial(fn) {
    var run = (root.__upsCartQ || Promise.resolve()).then(fn, fn);
    root.__upsCartQ = run.then(function () {}, function () {});
    return run;
  }

  // a téma kosár-felülete a hozzáadás után: NGM (Enterprise / Magazine Layer) — a fiók újrarajzolása és nyitása az ismert eseményekkel;
  // Horizon (MobilStore) — a téma saját `cart:update` eseménye a friss kosárral és a kosár-szekciókkal
  function cartSectionIds() {
    var ids = [];
    root.document.querySelectorAll('cart-items-component').forEach(function (e) { var s = e.dataset && e.dataset.sectionId; if (s && ids.indexOf(s) < 0) ids.push(s); });
    return ids;
  }
  function refreshTheme(sections) {
    var d = root.document;
    if (d.querySelector('cart-drawer')) {
      d.dispatchEvent(new root.CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      d.dispatchEvent(new root.CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      return;
    }
    cartJs().then(function (cart) {
      if (!cart) return;
      d.dispatchEvent(new root.CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'upsell-xs',
        data: { source: 'upsell-xs', itemCount: cart.item_count, sections: sections || {} } } }));
    });
  }

  function addToCart(item, button, text, qa) {
    button.disabled = true;
    var line = { id: item.v, quantity: 1 };
    if (!qa) line.properties = { _ups_src: ('xs:' + item.t + ':auto').slice(0, 40) };
    var body = { items: [line] }, secs = cartSectionIds();
    if (secs.length) body.sections = secs.join(',');
    return root.fetch(routesRoot() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok) throw new Error('add'); return b; });
    }).then(function (b) {
      button.textContent = text.added;
      try { refreshTheme(b && b.sections); } catch (e) { /* a téma frissítése nem kritikus: a tétel már a kosárban van */ }
    }).catch(function () { button.disabled = false; button.textContent = text.error; });
  }

  function card(it, text, cls, qa) {
    var url = productUrl(routesRoot(), it.x.handle);
    if (!url) return null;
    var li = el('li', 'uxs-card');
    li.setAttribute('data-t', it.t);
    var media = el('a', 'uxs-media');
    media.href = url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    var src = safeImg(it.x.img);
    if (src) {
      var im = el('img', 'uxs-img');
      im.src = src; im.alt = ''; im.width = 360; im.height = 360; im.loading = 'lazy'; im.decoding = 'async';
      im.addEventListener('error', function () { if (im.parentNode) im.parentNode.removeChild(im); });
      media.appendChild(im);
    }
    li.appendChild(media);
    li.appendChild(el('p', 'uxs-type ' + (cls.meta || ''), text.types[it.t] || ''));
    var name = el('a', 'uxs-name ' + (cls.title || ''), it.x.title);
    name.href = url;
    li.appendChild(name);
    var pr = el('p', 'uxs-price');
    pr.appendChild(el('span', 'uxs-now', fmt(it.x.price, text.currency)));
    if (it.x.was) pr.appendChild(cls.strike ? el('s', 'uxs-was', fmt(it.x.was, text.currency)) : el('span', 'uxs-was', String(text.rrp).replace('{pret}', fmt(it.x.was, text.currency))));
    li.appendChild(pr);
    var b = el('button', 'uxs-add ' + (cls.btn || ''), text.add);
    b.type = 'button';
    b.addEventListener('click', function () { addToCart(it, b, text, qa); });
    li.appendChild(b);
    return li;
  }

  function render(box, group, picks, text, qa) {
    var cls = { heading: box.getAttribute('data-cls-heading'), title: box.getAttribute('data-cls-title'), btn: box.getAttribute('data-cls-btn'), meta: box.getAttribute('data-cls-meta'),
                strike: box.getAttribute('data-was') === 'strike' };           // a bolt saját ár-kinézete: NGM „Preț recomandat: …”, MobilStore áthúzott ár
    box.textContent = '';
    var head = el('div', 'uxs-head');
    var name = typeof group.name === 'string' && group.name ? group.name.slice(0, 60) : null;
    var h = el('h2', 'uxs-title ' + (cls.heading || ''), name ? String(text.title).replace('{nume}', name) : text.titleAny);
    h.id = 'uxs-title-' + (box.getAttribute('data-pid') || '');
    head.appendChild(h);
    var nav = el('div', 'uxs-nav'), prev = el('button', 'uxs-arrow uxs-prev'), next = el('button', 'uxs-arrow uxs-next');
    prev.type = next.type = 'button';
    prev.setAttribute('aria-label', text.prev); next.setAttribute('aria-label', text.next);
    nav.appendChild(prev); nav.appendChild(next);
    head.appendChild(nav);
    box.appendChild(head);
    var track = el('ul', 'uxs-track');
    track.setAttribute('role', 'list');
    track.setAttribute('aria-labelledby', h.id);
    function put(it) { var c = card(it, text, cls, qa); if (c) track.appendChild(c); }
    picks.slice(0, FIRST).forEach(put);
    box.appendChild(track);
    var rest = picks.slice(FIRST);
    function more() { if (rest.length) { rest.forEach(put); rest = []; } }
    function arrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = !rest.length && track.scrollLeft >= max;
    }
    function step(dir) { more(); track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.9, 160), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { more(); arrows(); }, { passive: true });
    track.addEventListener('pointerdown', more, { passive: true });
    box.classList.add('is-on');
    arrows();
  }

  // adat → (ha kell) holdout → Storefront → kártyák. Visszaad: egy függvény, ami kirajzol (vagy null, ha nincs mit)
  function prepare(box) {
    var base = box.getAttribute('data-base') || '', shop = box.getAttribute('data-shop'), pid = box.getAttribute('data-pid') || '';
    if (!/^https:\/\/[^\s"'<>]+$/.test(base) || SHOPS.indexOf(shop) < 0 || !/^\d{1,20}$/.test(pid)) return Promise.resolve(null);
    var forced = /(?:^|[?&])upsell_preview=1(?:&|$)/.test((root.location && root.location.search) || '');
    var hu = /^hu/i.test(String((root.Shopify && root.Shopify.locale) || (root.document.documentElement && root.document.documentElement.lang) || ''));
    var text = Object.assign({}, TEXT, hu ? TEXT_HU : {}, root.UPSELL_XS_TEXT || {});
    text.types = Object.assign({}, TEXT.types, hu ? TEXT_HU.types : {});
    return getJson(base + '/index.json').then(function (idx) {
      var mode = decide(idx, shop, forced);
      if (mode === 'off' || mode === 'control') return null;
      return getJson(base + '/xs/' + shop + '/p/' + shard(pid) + '.json').then(function (sh) {
        var gk = sh && sh.v === 1 && sh.p && sh.p[pid];
        if (typeof gk !== 'string' || !/^[0-9a-f]{12}$/.test(gk)) return null;
        return Promise.all([getJson(base + '/xs/' + shop + '/g/' + gk + '.json'), cartJs()]).then(function (r) {
          var group = r[0], cart = r[1];
          if (!group || !Array.isArray(group.types)) return null;
          var grouped;
          if (mode === 'preview') grouped = Promise.resolve('preview');
          else {
            var token = cart && typeof cart.token === 'string' && cart.token ? cart.token : null;
            if (!token || !root.crypto || !root.crypto.subtle) return null;
            var pct = idx.xs.holdout_pct;
            grouped = stickyGroup(cart, '_ups_grp_x', pct, idx.holdout_salt_id, token).then(function (r) {
              return (r.mark ? markCart(cart, r.g === 'treatment' ? 't' : 'c') : Promise.resolve()).then(function () { return r.g; });
            });
          }
          return grouped.then(function (g) {
            if (g === 'control') return null;
            var p = plan(group, daySeed(), pid), ids = planIds(p);
            if (!ids.length) return null;
            var s = root.Shopify || {};
            var req = gql(ids, s.country, s.locale || (root.document.documentElement && root.document.documentElement.lang));
            return root.fetch(API, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(req) })
              .then(function (resp) { return resp.ok ? resp.json() : null; }).then(function (data) {
                var skip = { handle: box.getAttribute('data-handle') || null };
                ((cart && cart.items) || []).forEach(function (i) { skip[i.variant_id] = true; });
                var cap = isId(group.cap) ? group.cap : 2, max = isId(group.max) ? Math.min(group.max, 12) : 12;
                var picks = interleave(p, parseNodes(data), cap, max, skip);
                if (!picks.length) return null;
                return function () { render(box, group, picks, text, g === 'preview'); };
              });
          });
        });
      });
    });
  }

  function whenNear(box, fn) {
    if (typeof root.IntersectionObserver !== 'function') { fn(); return; }
    var io = new root.IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      fn();
    }, { rootMargin: '600px 0px' });
    io.observe(box);
  }

  function afterLoad(fn) {
    var go = function () { if (typeof root.requestIdleCallback === 'function') root.requestIdleCallback(fn, { timeout: 3000 }); else root.setTimeout(fn, 300); };
    if (root.document.readyState === 'complete') go(); else root.addEventListener('load', go, { once: true });
  }

  function start() {
    var box = root.document.querySelector('[data-upsell-xs]');
    if (!box || box.getAttribute('data-upsell-xs-done')) return;
    box.setAttribute('data-upsell-xs-done', '1');
    afterLoad(function () {
      prepare(box).then(function (draw) { if (draw) whenNear(box, draw); }, function () { /* hiba esetén nincs blokk */ });
    });
  }

  if (root.document && typeof module === 'undefined') {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start); else start();
    root.document.addEventListener('shopify:section:load', function () { start(); });
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { bucket: bucket, assignGroup: assignGroup, stickyGroup: stickyGroup, serial: serial, decide: decide, shard: shard, rotate: rotate, plan: plan, planIds: planIds,
      interleave: interleave, gql: gql, parseNodes: parseNodes, safeImg: safeImg, productUrl: productUrl, daySeed: daySeed, TEXT: TEXT, TEXT_HU: TEXT_HU };
  }
})(typeof window !== 'undefined' ? window : globalThis);
